import { GetCollectionByGroupUid } from "../getCollection/getCollectionByGroupUid"
import { Document } from "../../models"

type ItemPermission = 'public' | 'private' | 'limited' | 'open group' | 'closed group'

export type ItemPermissionsTranslaitons = Record<ItemPermission, string>

export const getItemPermissionsText = (translations: ItemPermissionsTranslaitons, getCollectionByGroupUid: GetCollectionByGroupUid) =>
    (document: Document): string => {

        if (document.isPrivate) {
            return translations.private
        }
        if (document.isLimitedToMembers) {
            return translations.limited
        }

        if (document.groupUid) {
            const collection = getCollectionByGroupUid(document.groupUid)
            if (collection) {
                if (collection.collectionGroup.isClosed) {
                    return translations['closed group']
                } else {
                    return translations['open group']
                }
            }
        }

        return translations.public
    }